import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { ReadingAidsPopupProps } from '../../types';

export enum AIDefinitionsActionType {
	UPDATE_KEYWORD_DECORATIONS = 'UPDATE_KEYWORD_DECORATIONS',

	TOGGLE_READING_AIDS_POPUP = 'TOGGLE_READING_AIDS_POPUP',
}

interface UpdateDecorations {
	type: AIDefinitionsActionType.UPDATE_KEYWORD_DECORATIONS;
	keywordDecorations: DecorationSet;
}

interface ToggleReadingAidsPopup {
	type: AIDefinitionsActionType.TOGGLE_READING_AIDS_POPUP;
	isReadingAidsPopupOpen: boolean;
	readingAidsPopupProps?: ReadingAidsPopupProps;
}

export type AIDefinitionsAction = UpdateDecorations | ToggleReadingAidsPopup;
